import axios from 'axios'

export const apiGetDesigns = (memberId) => {
  return axios.post(`/api/get-designs`, { memberId }).then(({ data }) => {
    return data
  })
}

export const apiCreateDesign = (exportUrl, designId, memberId) => {
  return axios
    .post(`/api/create-design`, { exportUrl, designId, memberId })
    .then(({ data }) => {
      return data
    })
}

export const apiDeleteDesign = (key) => {
  return axios.post(`/api/delete-design`, { key }).then(({ data }) => {
    return data
  })
}
